import { z } from 'zod';
import { paginationFiltersSchema } from 'utils/schemas';

export const adminDiscountCodesFiltersSchema = z
  .object({})
  .merge(paginationFiltersSchema);
